"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEarthOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm2.73 2.33l-.48 2.34a1 1 0 01-.66.75L13.72 8.7a3 3 0 00-2 2.18l-.66 3.55-.51-.11a1 1 0 01-.78-.84l-1-7.06A12 12 0 0116 4a11.73 11.73 0 012.73.33zM22 20.7a7 7 0 01-.36 2.22l-1.44 4.3a11.52 11.52 0 01-2.2.6V24.6a3 3 0 00-2.23-2.9l-.77-.2a1 1 0 01-.72-1.13l.51-3.1 6.41 1.37a1 1 0 01.79 1zM4 16a12 12 0 013-7.93l.8 5.68a3 3 0 002.34 2.52l2.68.58-.51 3.15a3 3 0 002.19 3.39l.76.2a1 1 0 01.74 1V28A12 12 0 014 16zm18.75 9.91l.79-2.36A9.19 9.19 0 0024 20.7v-1.08a3 3 0 00-2.37-2.94l-8.58-1.84.65-3.53a1 1 0 01.66-.71l3.86-1.29a3 3 0 002-2.24l.44-2.13a12 12 0 012.1 21z" })));
}
exports.default = SvgEarthOutline;
//# sourceMappingURL=EarthOutline.js.map